import axios from "@/vue/api/index";
import type {
  HighRiskReportConsultableType,
  HighRiskReportNewResponse,
  HighRiskReportPayload,
  HighRiskReportResult
} from "../model/types";

const BASE_PATH = "/api/v1/high_risk_reports";

export type FetchNewParams = {
  consultableType: HighRiskReportConsultableType;
  consultableId: string;
};

const fetchNew = async ({ consultableType, consultableId }: FetchNewParams): Promise<HighRiskReportNewResponse> => {
  const response = await axios.get(`${BASE_PATH}/new`, {
    params: { consultable_type: consultableType, consultable_id: consultableId }
  });

  return response.data as HighRiskReportNewResponse;
};

const create = async (payload: HighRiskReportPayload): Promise<HighRiskReportResult> => {
  const response = await axios.post(BASE_PATH, { high_risk_report: payload });

  return response.data.item as HighRiskReportResult;
};

export default { fetchNew, create };
